<template>
	<div id="app">
		<nav-header v-if="showTopFooter" />
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
		<nav-footer v-if="showTopFooter" />

		<!-- 滚动到顶部按钮 -->
		<button v-show="showBackToTop" class="back-to-top" @click="scrollToTop" aria-label="Back to top">↑</button>
	</div>
</template>

<script>
import NavHeader from './components/NavHeader.vue';
import NavFooter from './components/NavFooter.vue';

export default {
	name: 'App',
	components: {
		NavHeader,
		NavFooter
	},
	data() {
		return {
			showBackToTop: false,
			showTopFooter: true
		};
	},
	methods: {
		// 滚动到顶部
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth' // 平滑滚动
			});
		},
		// 监听滚动事件
		handleScroll() {
			this.showBackToTop = window.scrollY > 300; // 滚动超过 300px 显示按钮
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		document.body.className = `lang-${this.$i18n.locale}`;
		if(this.$route.query.from === 'app') {
			this.showTopFooter = false
			localStorage.setItem('from', 'app')
		}else{
			localStorage.removeItem('from', 'app')
		}
		if(this.$route.query.orderNo){
			localStorage.setItem('orderNo', this.$route.query.orderNo || '')
		}else{
			localStorage.removeItem('orderNo')
		}
		localStorage.setItem('subject',this.$route.query.subject);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	// 监听语言变化
	watch: {
		'$i18n.locale': function(newLocale) {
			document.body.className = `lang-${newLocale}`;
			// 根据当前语言环境更新页面标题
    		document.title = newLocale === 'en' ? 'VTimes' : '唯泰斯智能';
			// 根据当前语言环境更新页面图标
			const favicon = document.querySelector('link[rel="icon"]');
			if (favicon) {
				favicon.href = require('./assets/codelogo-zh.png');
				// 根据语言环境切换图标
				// if (newLocale === 'en') {
				// 	// 设置英文图标
				// 	favicon.href = require('./assets/codelogo-en.png');
				// } else {
				// 	// 设置中文图标
				// 	favicon.href = require('./assets/codelogo-zh.png');
				// }
			}
		}
	},
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

body {
	padding: 0;
	background: #f8f9fa;
	/* 定义CSS变量，默认使用中文颜色 */
	--active-nav-color: #30B4E9;
	--active-nav-hover-color: #0F8AB8;
}

/* 英文时覆盖变量值 */
body.lang-en {
	--active-nav-color: #30B4E9;
	--active-nav-hover-color: #0F8AB8;
  /* --active-nav-color: #FE5E10;
  --active-nav-hover-color: #D44F0D; */
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
/* 浮动按钮样式 */
.back-to-top {
	position: fixed;
	bottom: 30px;
	right: 30px;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: #007bff;
	color: white;
	border: none;
	cursor: pointer;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	transition: opacity 0.3s, transform 0.3s;
	z-index: 999;
}

.back-to-top:hover {
	background-color: #0056b3;
	transform: scale(1.1);
}
</style>
